import React, { useEffect, useState } from 'react';
import './ProfileCard.scss';
import {
  HOME_PAGE,
} from '../../../../common/homePageConstants';
import { getDataFromSession } from '../../../../utill.func';
import { commonConstant } from '../../../../common';
import { useHistory } from 'react-router-dom';
import {
  getCustomerAge,
  getCustomerGender,
} from '../../../../services/healthWellness/healthWellness.service';
import { GENDER } from '../../../../common/commonConstant';
import { fetchScoreCategoryMetadata } from '../../../../services/healthWellness/healthSpan.service';
import { resolveAgeGroup } from '../behaviorScoreCard/personImageConfig';

const ProfileCard = ({ customer }) => {
  const history = useHistory();
  const { pictureUrl, displayName } = getDataFromSession('lineProfile');
  const [ageGroupMetadata, setAgeGroupMetadata] = useState(null);

  const customerGender = Object.keys(GENDER).find(
    (item) => GENDER[item] === getCustomerGender()
  );
  const customerAge = getCustomerAge();
  const gender = customerGender?.toLowerCase() || 'male';
  const age = customerAge || 30;

  useEffect(() => {
    let cancelled = false;
    fetchScoreCategoryMetadata('health_span_age_group')
      .then((data) => {
        if (!cancelled) setAgeGroupMetadata(data?.metadata || null);
      })
      .catch(() => {
        if (!cancelled) setAgeGroupMetadata(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const { label: ageLabel } = resolveAgeGroup(age, gender, ageGroupMetadata);

  const redirectToProfileScreen = () => {
    history.push(commonConstant.pathProfile);
  };

  return (
    <>
        <div className="home-profile-container">
          <div className="food-profile-left">
            <div className="food-profile-img-container" onClick={redirectToProfileScreen}>
              <img src={pictureUrl} alt="line-profile-img" />
            </div>
          </div>
          <div className="home-profile-details">
            <div className="food-profile-title">
              {HOME_PAGE.HOME_GREETING_MSG}
            </div>
            <div className="food-profile-subtitle">{displayName}</div>
            <div className="home-profile-age-info">
              <span className="age-text">อายุ {age} ปี</span>
              {ageLabel && <span className="age-label">{ageLabel}</span>}
              {/* <img
                className="age-info-icon"
                src="/images/nutrition-and-rehabilitation/information-green.svg"
                alt="info"
              /> */}
            </div>
          </div>
        </div>
    </>
  );
};

export default ProfileCard;
